import { render, staticRenderFns } from "./InputTabsMulti.vue?vue&type=template&id=646917f8&scoped=true"
import script from "./InputTabsMulti.vue?vue&type=script&lang=js"
export * from "./InputTabsMulti.vue?vue&type=script&lang=js"
import style0 from "./InputTabsMulti.vue?vue&type=style&index=0&id=646917f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646917f8",
  null
  
)

export default component.exports